import aiCostsFiltersSignal, {
	setAiCostsFilters,
} from '@UI/Pages/Administration/AiCosts/Filters/Signals/aiCostsFiltersSignal';
import type AiCostFilterOptionsView from '@UI/Store/AiCosts/Views/AiCostFilterOptionsView';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';

type Props = { options: AiCostFilterOptionsView | null };

const OrganizationFilter: React.FC<Props> = ({ options }) => {
	const filters = useSignalValue(aiCostsFiltersSignal);

	const handleChange = React.useCallback((value: number | null) => {
		setAiCostsFilters(aiCostsFiltersSignal.peek().setOrganization(value));
	}, []);

	return (
		<Dropdown<number>
			name="aiCostsOrganization"
			label="Structure"
			placeholder="Toutes les structures"
			options={options?.organizations ?? []}
			loading={options === null}
			optionLabel="label"
			optionValue="id"
			showClear
			filter
			value={filters.organizationId}
			onChange={handleChange}
		/>
	);
};

export default OrganizationFilter;
